export const UserSettingTypes = {
  SHOW_USER_SETTINGS: "SHOW_USER_SETTINGS",
  UPDATE_USER_SETTINGS: "UPDATE_USER_SETTINGS",
  SHOW_TEMPLATE_SETTINGS: "SHOW_TEMPLATE_SETTINGS",
  UPDATE_TEMPLATE_SETTINGS: "UPDATE_TEMPLATE_SETTINGS",
};
